import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  DIALOG_DATA,
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { DashboardChartExports } from '../dashboard-state-service';
import { ReportChartExports } from '../../../hunt/final-hunt-report/final-hunt-report.component';

@Component({ standalone: false, 
  selector: 'export-options-dialog',
  templateUrl: './export-options-dialog.component.html',
  styleUrls: ['./export-options-dialog.component.scss'],
})
export class ExportOptionsDialogComponent implements OnInit {
  constructor(
    public dialogRef: DialogRef,
    public dialogService: DialogService,
    @Optional()
    @Inject(DIALOG_DATA)
    public exportOptions: DashboardChartExports[] | ReportChartExports[],
  ) {}
  public data: { text: string; items?: { text: string }[] }[] = [
    {
      text: 'Select all',
      items: [],
    },
  ];

  public nestedArchive: boolean = false;
  public checkedKeys: string[] = [];

  public ngOnInit(): void {
    this.exportOptions.forEach((option) => {
      this.data[0].items.push({ text: option });
    });
  }

  public onSubmit(): void {
    const indices = this.checkedKeys
      .filter((item) => item.includes('_'))
      .map((item) => {
        const parts = item.split('_');
        return parseInt(parts[parts.length - 1], 10);
      });
    // Use indices from checked keys to get selected export options
    const result = indices.map((index) => this.exportOptions[index]);
    this.dialogRef.close(result);
  }

  public onCheckedKeysChange(checkedKeys: string[]): void {
    this.checkedKeys = checkedKeys;
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
